/*
 * Copyright (c) 2024. Haodong JU
 */

export const defaultLanguage = () => [
  {
    lang: 'de',
    id: '1',
    name: ''
  },
  {
    lang: 'zh',
    id: '2',
    name: ''
  },
  {
    lang: 'en',
    id: '3',
    name: ''
  }
]
